<template>
  <div class="newhome">
    <!-- 能耗综览  newHome-->
    <selected @childEvent="childEvent"></selected>
    <div class="home" ref="print" :style="{background:defaultTheme}">
      <!-- 卡片 -->
      <el-row :gutter="13" class="ceng">
        <el-col :xs="24" :sm="16" :lg="8" :xl='8' class="card_box">
          <div class="card-panel" style="background:#8C79AC;">
            <div class="card-panel-icon-wrapper">
              <!-- <div class="el-icon-location"></div> -->
              <img src="@/assets/Overview/icon-20.png" alt="" />
              <p>综合能耗</p>
            </div>
            <div class="p_all" style="border-left: 1px solid #b2a1cf;">
              <p style="font-size:20px">{{comprehensiveTotal | guolv}}tce</p>
            </div>
            <img class="p" src="@/assets/Overview/icon-20n.png" alt="" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="4" :xl='4' class="card_box">
          <div class="card-panel" style="background: #E35C59;border: 2px solid #D74C49;">
            <div class="card-panel-icon-wrapper">
              <img src="@/assets/Overview/icon-21.png" alt="" />
              <p>总电耗</p>
            </div>
            <div class="p_all">
              <p>
                {{dian.Total | guolv}}kwh
              </p>
            </div>
            <img class="p" src="@/assets/Overview/icon-21n.png" alt="" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="4" :xl='4' class="card_box">
          <div class="card-panel" style="background: #5496CF;border: 2px solid #4779A5;">
            <div class="card-panel-icon-wrapper">
              <img src="@/assets/Overview/icon-22.png" alt="" />
              <p>总水耗</p>
            </div>
            <div class="p_all">
              <p>
                {{shui.Total | guolv}}t
              </p>
            </div>
            <img class="p" src="@/assets/Overview/icon-22n.png" alt="" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="4" :xl='4' class="card_box">
          <div class="card-panel" style="background: #43B7AE;border: 2px solid #2CA59C;">
            <div class="card-panel-icon-wrapper">
              <img src="@/assets/Overview/icon-23.png" alt="" />
              <p>总气耗</p>
            </div>
            <div class="p_all">
              <p>
                {{qi.Total | guolv}}m³
              </p>
            </div>
            <img class="p" src="@/assets/Overview/icon-23n.png" alt="" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="8" :lg="4" :xl='4' class="card_box">
          <div class="card-panel" style="background: #F59447;border: 2px solid #DF833B;">
            <div class="card-panel-icon-wrapper">
              <img src="@/assets/Overview/icon-24.png" alt="" />
              <p style=" white-space: nowrap; ">折算碳排量</p>
            </div>
            <div class="p_all">
              <p>
                {{EnergyCalculatingEequivalent | guolv}}co2
              </p>
            </div>
            <img class="p" src="@/assets/Overview/icon-24n.png" alt="" />
          </div>
        </el-col>
      </el-row>
      <!-- 第二层 -->
      <el-row :gutter="13" class="ceng">
        <!-- 区域概况 -->
        <el-col :xs="24" :sm="12" :lg="8" :xl='8'>
          <div class="jianchu">
            <div class="titles">区域概况</div>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-image :src="EnergyBuildingDate&&EnergyBuildingDate.buildingAppearancePhoto">
                  <div slot="error" class="image-slot">
                    <!-- <img src="@/assets/Overview/icon-25.png" alt="" /> -->
                    暂未绑定图片
                  </div>
                </el-image>
              </el-col>
              <el-col :span="16" class="box">
                <div class="right">
                  <el-row :gutter="10" class="top">
                    <el-col :span="18">
                      <div class="box">
                        <span class="rows">
                          <div class="t">区域名称:</div>
                          <div class="name">{{EnergyBuildingDate&&EnergyBuildingDate.name || '-'}}</div>
                        </span>
                        <span class="rows">
                          <div class="t">区域类型:</div>
                          <div class="name">{{optionsed[EnergyBuildingDate&&EnergyBuildingDate.energyBuildingTypeId] ||
                            '-' }}</div>

                        </span>
                        <span class="rows">
                          <div class="t">区域面积:</div>
                          <div class="name">{{EnergyBuildingDate&&EnergyBuildingDate.buildingArea || '-'}}平方米</div>
                        </span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <span class="more" @click="detail_status = true">
                        <p>更多信息</p>
                      </span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="bottom">
                    <el-col :span="6">
                      <div class="rows">
                        <div class="num">{{EnergyBuildingDate&&EnergyBuildingDate.inlineQuantity || '-'}}</div>
                        <div class="num">进线数量</div>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="rows">
                        <div class="num">{{EnergyBuildingDate&&EnergyBuildingDate.transformerQuantity || '-'}}</div>
                        <div class="num">变压器数量</div>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="rows">
                        <div class="num">{{EnergyBuildingDate&&EnergyBuildingDate.totalCapacityKVA || '-'}}</div>
                        <div class="num">总容量(KVA)</div>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="rows">
                        <div class="num">{{EnergyBuildingDate&&EnergyBuildingDate.monitorPoints || '-'}}</div>
                        <div class="num">监测点数</div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <!-- 能耗统计 -->

        <!-- 用能分析 -->
        <el-col :xs="24" :sm="12" :lg="8" :xl='8'>
          <div class="echart">
            <div class="titles">用能分析</div>
            <div class="box" style="padding: 0;">
              <div id="chart_example" style="width:100%"></div>
            </div>
          </div>
        </el-col>
        <!-- 安全告警 -->
        <el-col :xs="24" :sm="12" :lg="8" :xl='8'>
          <div class="echart">
            <div class="titles">安全告警</div>
            <div class="box">
              <div id="chart_example2" style="width:100%"></div>
              <div class="params">
                <div class="left">
                  <div class="num">{{EventLevelsNum}}</div>
                  <div class="txt">总警告数</div>
                </div>
                <div class="right">
                  <!-- this.list.EventLevels Name Quantity -->
                  <div class="em" v-for="(item,index) in this.list.EventLevels" :key="index">
                    <div class="txt">{{item.name}}</div>
                    <div class="num">{{item.value}}</div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!--第三层 echart图 -->
      <el-row :gutter="13" class="ceng">
        <el-col :xs="24" :sm="12" :lg="8" :xl='8'>
          <div class="echart" style="height: 164px;">
            <div class="titles">能耗占比</div>
            <el-row class="box">
              <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="pro">
                  <el-progress :stroke-width="3" type="circle" :width="56" color="#F1CB32"
                    :percentage="EnergyIndicatorData.length ==0 ? 0: EnergyIndicatorData[0].proportion"
                    :indeterminate="true" :duration="5">
                    <template #default="{ percentage }">
                      <span>{{percentage }}%</span>
                    </template>
                  </el-progress>
                  <span class="txt">{{ EnergyIndicatorData.length ==0 ? '0': EnergyIndicatorData[0].targetTotal |
                    guolv}}tce</span>
                  <p class="pt">年度综合用能指标</p>
                </div>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="pro">
                  <el-progress :stroke-width="3" type="circle" :width="56" color="#1DB593"
                    :percentage="EnergyIndicatorData.length ==0 ? 0: EnergyIndicatorData[1].powerProportion"
                    :indeterminate="true" :duration="5">
                    <template #default="{ percentage }">
                      <span>{{ percentage }}%</span>
                    </template>
                  </el-progress>
                  <span class="txt">{{EnergyIndicatorData.length ==0 ? '0': EnergyIndicatorData[1].annualPlanUsePower |
                    guolv}}kWh</span>
                  <p class="pt">年度用电指标</p>
                </div>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="pro">
                  <el-progress :stroke-width="3" type="circle" :width="56" color="#6071F2"
                    :percentage="EnergyIndicatorData.length ==0 ? 0: EnergyIndicatorData[2].areaProportion || 0"
                    :indeterminate="true" :duration="5">
                    <template #default="{ percentage }">
                      <span>{{ percentage }}%</span>
                    </template>
                  </el-progress>
                  <span class="txt">{{EnergyIndicatorData.length ==0 ? '0': EnergyIndicatorData[2].buildingAreaIndicator
                    | guolv}}tce</span>
                  <p class="pt">单位面积能耗指标</p>
                </div>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <div class="pro">
                  <el-progress :stroke-width="3" type="circle" :width="56" color="#60ACF2"
                    :percentage="EnergyIndicatorData.length ==0 ? 0: EnergyIndicatorData[3].peopleProportion || 0"
                    :indeterminate="true" :duration="5">
                    <template #default="{ percentage }">
                      <span>{{ percentage }}%</span>
                    </template>
                  </el-progress>
                  <span class="txt">{{EnergyIndicatorData.length ==0 ? '0':
                    EnergyIndicatorData[3].buildingPopulationIndicator | guolv}}tce</span>
                  <p class="pt">单位人均能耗指标</p>
                </div>
              </el-col>
            </el-row>

          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="16" :xl='16'>
          <!-- echart图 -->
          <el-row class="echarted">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <div class="tit">用电分析</div>
              <div class="left">
                <div class="tit">
                  <img src="@/assets/airportTopMenu/电2.png" alt="">
                </div>
                <div class="data">
                  <div class="bom">
                    <div class="em">
                      <!-- <div class="name">去年同期</div> -->
                      <div class="name">同比</div>
                      <div class="num">{{dian.value4}} kWh</div>
                    </div>
                    <div class="em">
                      <!-- <div class="name">同比</div> -->
                      <div class="name">总量</div>
                      <div class="num">
                        <!-- <i :class="dian.value3>0 ? 'el-icon-top' : 'el-icon-bottom'"></i>{{dian.value3 | guolv}} -->
                        {{dian.value3 | guolv}} kWh
                      </div>
                    </div>
                  </div>
                  <div class="bom" v-show="valueIndex!=2">
                    <!-- <div class="em">
                    <div class="name">{{valueIndex==0?'昨天':valueIndex==1?'上月':'去年'}}用电</div>
                    <div class="num">{{dian.value2 | guolv}} kWh</div>
                  </div> -->
                    <div class="em">
                      <div class="name">环比</div>
                      <div class="num">
                        <i :class="dian.value1>0 ? 'el-icon-top' : 'el-icon-bottom'"></i>{{dian.value1 | guolv}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="18" :xl="18">
              <div id="middle" style="flex:1;height:165px;"></div>
            </el-col>
          </el-row>

        </el-col>
      </el-row>

      <!-- 第四层 -->
      <el-row :gutter="13" style="width: 101%;">
        <!-- 用能占比 -->
        <el-col :xs="24" :sm="24" :lg="8" :xl='8'>
          <div class="proportion">
            <div class="titles">用能占比</div>
            <div id="proportion" style="width:110%"></div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="16" :xl='16'>
          <div class="r" style="flex:1">
            <!-- echart图 -->
            <el-row class="echarted">
              <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
                <div class="tit">用水分析</div>
                <div class="left">
                  <div class="tit"> <img src="@/assets/airportTopMenu/水2.png" alt=""></div>
                  <div class="data">
                    <div class="bom">
                      <div class="em">
                        <!-- <div class="name">去年同期</div> -->
                        <div class="name">同比</div>
                        <div class="num">{{shui.value4 | guolv}} t</div>
                      </div>
                      <div class="em">
                        <!-- <div class="name">同比</div> -->
                        <div class="name">总量</div>
                        <div class="num">
                          <!-- <i :class="shui.value3>0 ? 'el-icon-top' : 'el-icon-bottom'"></i>{{shui.value3 | guolv}} -->
                          {{shui.value3 | guolv}} t
                        </div>
                      </div>
                    </div>
                    <div class="bom" v-show="valueIndex!=2">
                      <!-- <div class="em">
                          <div class="name">{{valueIndex==0?'昨天':valueIndex==1?'上月':'去年'}}用水</div>
                          <div class="num">{{shui.value2 | guolv}} m³</div>
                        </div> -->
                      <div class="em">
                        <div class="name">环比</div>
                        <div class="num">
                          <i :class="shui.value1>0 ? 'el-icon-top' : 'el-icon-bottom' "></i>{{shui.value1 | guolv}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18">
                <div id="middle2" style="height:165px;"></div>
              </el-col>
            </el-row>

            <!-- echart图 -->
            <el-row class="echarted" style="margin-top:14px">
              <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
                <div class="tit">用气分析</div>
                <div class="left">
                  <div class="tit"> <img src="@/assets/airportTopMenu/气2.png" alt=""></div>
                  <div class="data">
                    <div class="bom">
                      <div class="em">
                        <!-- <div class="name">去年同期</div> -->
                        <div class="name">同比</div>
                        <div class="num">{{qi.value4 | guolv}} m³</div>
                      </div>
                      <div class="em">
                        <!-- <div class="name">同比</div> -->
                        <div class="name">总量</div>
                        <div class="num">
                          <!-- <i :class="qi.value3>0 ? 'el-icon-top' : 'el-icon-bottom'"></i>{{qi.value3 | guolv}} -->
                          {{qi.value3 | guolv}} m³
                        </div>
                      </div>
                    </div>
                    <div class="bom" v-show="valueIndex!=2">
                      <!-- <div class="em">
                      <div class="name">{{valueIndex==0?'昨天':valueIndex==1?'上月':'去年'}}用气</div>
                      <div class="num">{{qi.value2 | guolv}} m³</div>
                    </div> -->
                      <div class="em">
                        <div class="name">环比</div>
                        <div class="num">
                          <i :class=" qi.value1>0 ? 'el-icon-top' : 'el-icon-bottom' "></i>{{qi.value1 | guolv}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18">
                <div id="middle3" style="flex: 1;height:165px;"></div>
              </el-col>
            </el-row>

          </div>
        </el-col>

      </el-row>
      <!-- 遮罩层 -->
      <div class="mask" v-if="isMask">
        <i class="el-icon-loading" style="color:#409eff;font-size:60px"></i>
      </div>
    </div>

    <!-- 区域概况详情 -->
    <el-dialog title="区域概况" v-dialogDrag :visible.sync="detail_status" width="800px" center>
      <el-form :inline="true" ref="temp" label-width="143px" class="demo-temp">
        <el-form-item v-for="(item,index) in columns" :key='index' :label="item.name" :prop="item.key">
          <!-- <span v-if="item.key=='buildingAppearancePhoto'" style="display: flex;align-items: center;" class="beijing">
            <el-image v-if="item.key=='buildingAppearancePhoto'" style="width: 100px; height: 100px"
              :src="EnergyBuildingDate[item.key]" :preview-src-list="[EnergyBuildingDate.buildingAppearancePhoto]">
            </el-image>
          </span> -->
          <span v-if="item.key=='buildingAppearancePhoto'"
            style="display: flex;flex-direction: column;position: relative;" class="beijing">
            <input style="opacity: 0;margin-bottom: 54px;"></input>
            <el-image v-if="item.key=='buildingAppearancePhoto'"
              style="width: 100px;margin-right: 15px;position: absolute;" :src="EnergyBuildingDate[item.key]"
              :preview-src-list="[EnergyBuildingDate.buildingAppearancePhoto]">

            </el-image>
          </span>
          <span v-else-if="item.key=='energyBuildingTypeId'">
            <el-select style="width: 177px;" v-model="optionsed[EnergyBuildingDate.energyBuildingTypeId]" clearable
              placeholder="请选择" disabled>
              <el-option v-for="(item,i) in optionsed" :key="i" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </span>


          <span v-else-if="item.key == 'coordinate'">
            <input v-model="EnergyBuildingDate.coordinate" readonly>
          </span>
          <!-- <span v-else style="width:200px;display: inline-block;">{{EnergyBuildingDate[item.key] }}</span> -->
          <input v-else v-model="EnergyBuildingDate[item.key]" :placeholder="'请输入'+item.name" disabled>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="detail_status = false">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>

  </div>
</template>

<script>
  import {getEnergyStatistics,countUnitEvents} from "../../api/abbNewApi";
  import {findAllBuildingType,getTransformerByAreaId} from "../../api/buildingApi";
  import {getAreaByAreaId} from "../../api/energySubArea";
  import * as echarts from "echarts";
  import axios from 'axios';
  require("echarts/theme/macarons"); //引入主题
  // require('echarts/theme/macarons') // echarts theme
  import selected from '@/components/module/temp/select_left.vue';
  // import { parseTime } from "@/utils";
  import $ from 'jquery';
  let middle,proportion,middle2,middle3,myChart,myChart2;
  export default {
    components: {selected},
    data () {
      return {
        comprehensiveTotal: 0,//综合能耗
        EnergyCalculatingEequivalent: 0,//碳转换系数
        isMask: false,//遮罩层
        defaultTheme: "#eceef2",
        listData: "B5A693FA77804BC8BE009D57D0E7A788",
        // nowBuilding:"",
        dataUrl: 'http://10.50.0.134:8080/#/?userCode=&password=admin',
        EventLevelsNum: 0,
        tan: 0,
        flaged: false,
        optionsed: {},
        columns: [{
          name: "名称",
          key: "name",
          width: 170
        },{
          name: "编号",
          key: "code"
        }
          ,{
          name: "区域外观图",
          key: "buildingAppearancePhoto",
          width: 120
        }
          ,{
          name: "区域类型",
          key: "energyBuildingTypeId",
          width: 120,
        }
          ,{
          name: "进线来源",
          key: "inlineSource"
        }
          ,{
          name: "进线数量(个)",
          key: "inlineQuantity"
        }
          ,{
          name: "区域面积(m³)",
          key: "buildingArea"
        }
          ,{
          name: "变压器数量(个)",
          key: "transformerQuantity",
          width: 120
        }
          ,{
          name: "总容量(KVA)",
          key: "totalCapacityKVA",
          width: 120
        }
          ,{
          name: "监测点数(个)",
          key: "monitorPoints"
        }
          ,{
          name: "电房数量(个)",
          key: "electricRoomQuantity"
        }
          ,{
          name: "负荷容量(KVA)",
          key: "burdenCapacity"
        }

          ,{
          name: "年度计划用电(kwh)",
          key: "annualPlanUsePower",
          width: 165
        },{
          name: "坐标",
          key: "coordinate",
          width: 165
        },
        {
          name: "年度计划用水(t)",
          key: "annualPlanUseWater"
        },{
          name: "年度计划用气(m³)",
          key: "annualPlanUseGas"
        },{
          name: "区域面积指标(m³)",
          key: "buildingAreaIndicator"
        },{
          name: "区域人数(人)",
          key: "buildingPopulation"
        },{
          name: "区域人数指标(人)",
          key: "buildingPopulationIndicator"
        },{
          name: "备注",
          key: "memo"
        }
        ],
        EnergyIndicatorData: [],
        detail_status: false,
        valueIndex: 0,
        valueId: '',
        options: {
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}   ({d}%)'
          },
          legend: {
            data: ["电","水","天然气"],
            top: 170,
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            itemGap: 30, // 设置间距
          },
          label: {
            alignTo: "edge",
            formatter: "{name|{b}}\n{time|{c}}",
            minMargin: 0,
            edgeDistance: 10,
            lineHeight: 15,
            position: "outer",
            margin: 10,
            rich: {
              time: {
                fontSize: 10,
                color: "#999",
              },
            },
            normal: {
              textStyle: {
                fontSize: 24,
              }
            }
          },

          // color: ["#60acf2", "#6071f2", "#36cbcb"],
          color: ["#36cbcb","#52a1ff","#ff8a00"],
          series: [
            {
              name: "用能分析",
              type: "pie",
              radius: "65%",
              center: ["53%","46%"],
              itemStyle: {
                borderColor: "#fff",
                borderWidth: 1,
              },
              labelLine: {
                normal: {
                  length: 0
                }
              },
              data: [
                {value: 10,name: "电"},
                {value: 20,name: "水"},
                {value: 10,name: "天然气"},
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        },
        options2: {
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}   ({d}%)'
          },
          label: {
            alignTo: "edge",
            position: "outer",
            formatter: "{name|{b}}\n{time|{c}}",

            minMargin: 15,
            edgeDistance: 10,
            lineHeight: 15,
            rich: {
              time: {
                fontSize: 10,
                color: "#999",
              },
            },
          },
          color: ["#4ecb73","#f59447","#f1cb32"],
          series: [
            {
              name: "安全警告",
              type: "pie",
              radius: "75%",
              center: ["58%","40%"],
              itemStyle: {
                borderColor: "#fff",
                borderWidth: 1,
              },
              data: [
                {value: 0,name: "消息"},
                {value: 0,name: "警告"},
                {value: 0,name: "预警"},
              ],
              labelLine: {
                normal: {
                  length: 0
                }
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        },
        EnergyBuildingDate: {
        },
        numed: 0,
        list: {
          BasisCompareTotals: [{}],
          EnergyTotalValues: [{}],
          RatioCompareTotals: [{}],
          ThisIssueValues: [{}],
        },
        shui: {
          Total: 0,
        },
        dian: {
          value1: 0,
          value2: 0,
          value3: 0,
          value4: 0,
          Total: 0,
        },
        qi: {
          Total: 0
        },
        iconStatused: false,
        proportionData: {
          grid: {
            top: "8%",
            left: 80,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          toolbox: {
            show: true,
            showTitle: false, // 隐藏默认文字，否则两者位置会重叠
            top: '-5',
            right: "50",
            feature: {
              magicType: {
                type: ['line','bar','stack','tiled'],title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },

              saveAsImage: {
                show: true,
                title: '下载图片'
              },
              // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
            },
            tooltip: { // 和 option.tooltip 的配置项相同
              show: true,
              formatter: function(param) {
                return '<div>'+param.title+'</div>'; // 自定义的 DOM 结构
              },
              backgroundColor: '#fff',
              textStyle: {
                fontSize: 12,
              },
              extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // 自定义的 CSS 样式
            }
          },
          color: ["#ff8a00","#52a1ff","#36cbcb"],
          legend: {
            data: ["电","水","天然气"],
            top: 245,
            icon: "rect", //  
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度
            textStyle: {
              lineHeight: 56,
              fontSize: 14,
            },
            itemGap: 50, // 设置间距
          },

          xAxis: {
            splitLine: {
              //网格线
              show: true,
            },
            type: "category",

            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,

            },
            axisLine: {
              show: false,
            },
            z: 99,
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "天然气",
              data: [0,0,0,0,0,0,0,0,0,0,0,0,],
              type: "bar",
              stack: "total",

              emphasis: {
                focus: "series",
              },
            },
            {
              name: "水",
              data: [0,0,0,0,0,0,0,0,0,0,0,0,],
              type: "bar",
              stack: "total",

              emphasis: {
                focus: "series",
              },
            },
            {
              name: "电",
              data: [0,0,0,0,0,0,0,0,0,0,0,0,],
              type: "bar",
              stack: "total",

              emphasis: {
                focus: "series",
              },
            },
          ],
        },
        middleData: {
          grid: {
            right: 10,
            left: 80,
            top: 20,
            bottom: 40,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          color: ["#36cbcb"],

          xAxis: {
            splitLine: {
              //网格线
              show: true,
            },
            type: "category",
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#000',
                fontSize: '16'
              }
            },
            axisLine: {
              show: false,
            },
            z: 99,
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: [0,0,0,0,0,0,0,0,0,0,0,0,],
              type: "bar",
              center: ["50%","53%"],
              barWidth: 15, //柱图宽度
            },
          ],
        },
        middleData2: {
          grid: {
            right: 10,
            left: 80,
            top: 20,
            bottom: 40,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          color: ["#52a1ff"],

          xAxis: {
            splitLine: {
              //网格线
              show: true,
            },
            type: "category",
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#000',
                fontSize: '16'
              }
            },
            axisLine: {
              show: false,
            },
            z: 99,
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: [0,0,0,0,0,0,0,0,0,0,0,0,],
              type: "bar",
              center: ["50%","53%"],
              barWidth: 15, //柱图宽度
            },
          ],
        },
        middleData3: {
          grid: {
            right: 10,
            left: 80,
            top: 20,
            bottom: 40,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          color: ["#ff8a00"],

          xAxis: {
            splitLine: {
              //网格线
              show: true,
            },
            type: "category",
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#000',
                fontSize: '16'
              }
            },
            axisLine: {
              show: false,
            },
            z: 99,
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: [0,0,0,0,0,0,0,0,0,0,0,0,],
              type: "bar",
              center: ["50%","53%"],
              barWidth: 15, //柱图宽度
            },
          ],
        },
        timerType: "DAY",
        nowArea: {},//当前区域
        dayData: [],
        yearData: [],
        monthData: []

      };
    },
    //利用计算属性
    computed: {

      nowBuilding () {//当前区域
        return this.$store.cacheStore.state.setBuilding;
      }

    },
    //监听执行
    watch: {
      nowBuilding (val) {
        this.nowArea=val
        this.getAreaByArea_fn()
        this.temp_fn(this.timerType)
      },
      listData (val) {//监视单位改变
        //alert(val)
        this.valueId=val;
        this.childEvent(this.valueIndex);

      }
    },

    filters: {
      guolv: function(v) {
        if(!isNaN(v)&&v) {
          var roundedNum=Math.round(Number(v)*100)/100;
          return Number(roundedNum).toFixed(2)
        } else {
          return '-'
        }
      }
    },
    mounted () {

      //获取区域类型
      findAllBuildingType().then(res => {
        if(res.success) {
          res.data.forEach(item => {
            this.optionsed[item.id]=item.name
          })
        }
      })

      this.nowArea=this.$store.cacheStore.state.setBuilding
      this.getAreaByArea_fn()
      this.init();//echarts图初始化
      this.temp_fn("DAY");//默认获取日 数据
      for(let i=1;i<=31;i++) {
        if(i<=24) {
          this.dayData.push(i)
        }
        if(i<=12) {
          this.yearData.push(i+'月')
        }
        this.monthData.push(i);
      }
    },
    methods: {

      //获取区域详情
      getAreaByArea_fn () {
        //  this.isMask = true
        if(!this.nowArea.id) {
          return
        }
        getAreaByAreaId({'areaId': this.nowArea.id}).then(res => {
          if(res.code==200) {
            // this.isMask = false
            //如果没有是null说明没绑定
            if(res.data==null) {
              this.EnergyBuildingDate={};
              this.$message({type: 'warning',message: '该区域暂无添加区域详情信息'});

            } else { //有数据代表已经绑定 
              setTimeout(() => {
                this.EnergyBuildingDate=Object.assign({},res.data)
                getTransformerByAreaId({'areaId': this.nowArea.id}).then(res => {
                  if(res.code==200) {
                    this.EnergyBuildingDate.transformerQuantity=res.data.transformerNum;
                    this.EnergyBuildingDate.totalCapacityKVA=res.data.transformerCapacity
                  }
                })
              },1000);
            }
          } else {
            //  this.isMask = false
            this.$message({showClose: true,message: `获取失败${res.message}`,type: 'warning'});
          }
        })
      },
      childEvent (v) {

        this.valueIndex=v;
        if(v===0) {
          this.timerType="DAY"
          this.temp_fn("DAY");
        }
        if(v===1) {
          this.timerType="MONTH"
          this.temp_fn("MONTH");
        }
        if(v===2) {
          this.timerType="YEAR"
          this.temp_fn("YEAR");
        }
      },
      temp_fn (type) {
        var d={
          "areaId": this.nowArea.id,
          "timeType": type
        }

        if(!d.areaId) {
          return
        }
        this.isMask=true
        // 能源建设分析日
        getEnergyStatistics(d).then(res => {
          if(res.code==200) {
            res.data.ThisIssueValues.forEach(item => {
              item.Values=[item.Values]
            })
            this.list=res.data;
            this.dataSelect(res)

          } else {
            this.isMask=false
            this.errorData()
            this.$message({showClose: true,message: `获取失败${res.message}`,type: 'warning'});
          }
        })
      },
      //分配数据
      dataSelect (res) {

        // 安全警告
        // if (!res.data.EventLevels) {
        //   res.data.EventLevels =[{Name: "消息", Quantity: 70},{Name: "预警", Quantity: 65},{Name: "告警", Quantity: 25}]
        // }
        // this.EventLevelsNum =0;//安全警告 总数
        // this.options2.series[0].data =[];//饼图 数据
        // countUnitEvents().then(res => {
        // })
        // res.data.EventLevels.map(v=>{
        //   this.EventLevelsNum+=v.Quantity
        //   this.options2.series[0].data.push({
        //     name:v.Name,
        //     value:v.Quantity
        //   })
        // })
        // myChart2.setOption(this.options2,true);

        this.EventLevelsNum=0;//安全警告 总数
        this.options2.series[0].data=[];//饼图 数据
        countUnitEvents().then(res => {
          if(res.success) {
            this.EventLevelsNum=res.data.allCount
            var d=[
              {
                'name': "消息",
                'value': 0
              },
              {
                'name': "告警",
                'value': res.data.allGjCount
              },
              {
                'name': "预警",
                'value': res.data.allYjCount
              },
            ]
            this.list.EventLevels=d
            this.options2.series[0].data=d
            myChart2.setOption(this.options2,true);
          } else {
            this.$message({showClose: true,message: `获取安全警告失败`,type: 'warning'});
          }
        })


        //能耗占比

        this.EnergyIndicatorData=res.data.EnergyIndicatorData;

        this.flaged=true;
        //检测
        this.comprehensiveTotal=0
        this.EnergyCalculatingEequivalent=0

        res.data.EnergyTotalValues.map((v,index) => {
          //环比
          // if(index==0) {
          //   this.EnergyCalculatingEequivalent=v.EnergyCalculatingEequivalent
          // }
          this.EnergyCalculatingEequivalent+=(v.EnergyCalculatingEequivalent*v.Total)
          //综合能耗
          this.comprehensiveTotal+=v.TranslateRatioTotal
          if(v.EnergyName=="电") {
            this.dian.value1=v.LinkRelativeRatio; //环比
            this.dian.value3=v.Total; //总量
            this.dian.Total=v.Total; // 用能分析
            this.dian.value4=v.BeforeTotal;
          }
          if(v.EnergyName=="水") {
            this.shui.value1=v.LinkRelativeRatio;
            this.shui.value3=v.Total; //总量
            this.shui.Total=v.Total;
            this.shui.value4=v.BeforeTotal;
          }
          if(v.EnergyName=="气") {
            this.qi.value1=v.LinkRelativeRatio;
            this.qi.value3=v.Total; //总量
            this.qi.value4=v.BeforeTotal;
            this.qi.Total=v.Total;
            //  EnergyCalculatingEequivalent
          }
        });
        this.tan=0;
        res.data.ThisIssueValues.map((v) => {
          //本期
          if(v.EnergyName=="电") {
            var d=(this.dian.Values=v.Values[0]);
            var i=1;
            this.middleData.series[0].data=[];
            this.proportionData.series[2].data=[];
            var b=[]
            for(const key in d) {
              if(Object.hasOwnProperty.call(d,key)) {
                const element=d[key];
                if(key.indexOf("Value")==0) {
                  b.push(i++);
                  element? this.middleData.series[0].data.push(element.toFixed(2)):this.middleData.series[0].data.push(element);
                  element? this.proportionData.series[2].data.push(element.toFixed(2)):this.proportionData.series[2].data.push(element);
                }
              }
            }
            var dataType=[]
            if(this.timerType=="DAY") {
              dataType=this.dayData
            } else if(this.timerType=="MONTH") {
              dataType=this.monthData
            } else {
              dataType=this.yearData
            }
            this.middleData.xAxis.data=dataType;
            this.proportionData.xAxis.data=dataType;
            middle.setOption(this.middleData,true);
          }
          //本期
          if(v.EnergyName=="水") {
            var d=(this.shui.Values=v.Values[0]);
            var i=1;
            this.middleData2.series[0].data=[];
            var b=[]
            for(const key in d) {
              if(Object.hasOwnProperty.call(d,key)) {
                const element=d[key];
                if(key.indexOf("Value")==0) {
                  b.push(i++);
                  element? this.middleData2.series[0].data.push(element.toFixed(2)):this.middleData2.series[0].data.push(element);
                }
              }
            }
            var dataType=[]

            if(this.timerType=="DAY") {
              dataType=this.dayData
            } else if(this.timerType=="MONTH") {
              dataType=this.monthData
            } else {
              dataType=this.yearData
            }
            this.middleData2.xAxis.data=dataType;
            middle2.setOption(this.middleData2,true);
          }
          //本期
          if(v.EnergyName=="气") {
            var d=(this.shui.Values=v.Values[0]);
            var i=1;
            this.middleData3.series[0].data=[];
            var b=[]
            for(const key in d) {
              if(Object.hasOwnProperty.call(d,key)) {
                const element=d[key];
                if(key.indexOf("Value")==0) {
                  b.push(i++);
                  element? this.middleData3.series[0].data.push(element.toFixed(2)):this.middleData3.series[0].data.push(element);
                }
              }
            }
            var dataType=[]

            if(this.timerType=="DAY") {
              dataType=this.dayData
            } else if(this.timerType=="MONTH") {
              dataType=this.monthData
            } else {
              dataType=this.yearData
            }
            this.middleData3.xAxis.data=dataType;
            middle3.setOption(this.middleData3,true);
          }
        });
        this.proportionData.series[2].data=this.middleData.series[0].data;
        this.proportionData.series[1].data=this.middleData2.series[0].data;
        this.proportionData.series[0].data=this.middleData3.series[0].data;
        proportion.setOption(this.proportionData,true);

        this.options.series[0].data[0].value=this.dian.Total? this.dian.Total.toFixed(2):this.dian.Total;
        this.options.series[0].data[1].value=this.shui.Total? this.shui.Total.toFixed(2):this.shui.Total;
        this.options.series[0].data[2].value=this.qi.Total? this.qi.Total.toFixed(2):this.qi.Total;
        // 用能分析
        myChart.setOption(this.options,true);
        this.isMask=false
      },
      //请求失败清空数据
      errorData () {
        this.middleData.xAxis.data=[];
        this.proportionData.xAxis.data=[];
        this.middleData.series[0].data=[];
        middle.setOption(this.middleData,true);
        this.middleData2.series[0].data=[];
        this.middleData2.xAxis.data=[];
        middle2.setOption(this.middleData2,true);
        this.middleData3.series[0].data=[];
        this.middleData3.xAxis.data=[];
        middle3.setOption(this.middleData3,true);
        this.EventLevelsNum=0;//安全警告 总数
        this.options2.series[0].data=[];//饼图 数据
        myChart2.setOption(this.options2,true);
        this.list.EventLevels=[]
        this.shui.value1=0
        this.shui.value3=0 //总量
        this.shui.Total=0
        this.shui.value4=0
        this.dian.value1=0; //环比
        this.dian.value3=0; //总量
        this.dian.Total=0; // 用能分析
        this.dian.value4=0;
        this.qi.value1=0
        this.qi.value3=0
        this.qi.value4=0
        this.qi.Total=0
        this.comprehensiveTotal=0
        this.EnergyIndicatorData=[]

        this.proportionData.series[2].data=[]
        this.proportionData.series[1].data=[]
        this.proportionData.series[0].data=[]
        proportion.setOption(this.proportionData,true);

        this.options.series[0].data[0].value=0;
        this.options.series[0].data[1].value=0;
        this.options.series[0].data[2].value=0;
        myChart.setOption(this.options,true);
      },
      init () {
        // 饼图
        myChart=echarts.init( document.getElementById("chart_example"));
        myChart.setOption(this.options,true);
        myChart.resize({height: 200});

        myChart2=echarts.init(document.getElementById("chart_example2"));
        myChart2.setOption(this.options2,true);
        myChart2.resize({height: 125});
        //中间柱状图
        middle=echarts.init(document.getElementById("middle"));
        middle.setOption(this.middleData,true);
        middle.resize();
        //中间柱状图 用水
        middle2=echarts.init(document.getElementById("middle2"));
        middle2.setOption(this.middleData2,true);
        middle2.resize();

        $(window).resize(function() {
          middle2.resize();
          middle3.resize();
        });
        //中间柱状图
        middle3=echarts.init(document.getElementById("middle3"));
        middle3.setOption(this.middleData3,true);
        middle3.resize();
        //用能占比
        proportion=echarts.init(document.getElementById("proportion"));
        proportion.setOption(this.proportionData,true);
        proportion.resize({height: 293});

        $(window).resize(function() {
          myChart.resize({height: 200});
          myChart2.resize({height: 125});
          middle.resize();

          proportion.resize({height: 293});
        });
      },



      tableRowClassName ({row,rowIndex}) {
        if(rowIndex%2===0) {
          return "success-row";
        }
      },
    },

  };
</script>
<style>
  .jianchu img {
    width: 100%;
    height: 195px;
    object-fit: cover;
    background: burlywood;
  }
</style>

<style lang="scss" scoped>
  /deep/.el-dialog {
    margin-top: 5vh !important;
  }

  .newhome {
    padding: 0px !important;
  }

  .mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2020;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ceng {
    width: 101%;
  }

  .home {
    padding: 0px 15px 10px 10px;
    background: #eceef2;
    position: relative;
  }




  // 用能占比
  .proportion {
    background: #fff;
    box-sizing: border-box;
    padding-left: 23px;
    padding-right: 13px;
    padding-bottom: 11px;
    overflow: hidden;
    margin-top: 12px;

    .titles {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #5f5f5f;
      margin-top: 10px;
      margin-bottom: 9px;
    }
  }

  // 用电分析
  .echarted {
    flex: 1;
    background: #fff;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 30px;

    margin-top: 8px;

    .right {
      .right_pro {
        display: flex;
        flex-direction: column;
        align-items: center;

        .pt {
          font-size: 11px;
          color: #3d3d3d;
          margin-top: 9px;
        }
      }
    }

    .tit {
      font-size: 14px;
      font-weight: bold;
      color: #5f5f5f;
      margin-top: 10px;
    }

    .left {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #5f5f5f;
      margin-top: 5px;

      .tit {
        letter-spacing: 3px;
        margin-right: 13px;
        writing-mode: vertical-lr;
        /*从左向右 从右向左是 writing-mode: vertical-rl;*/
        writing-mode: tb-lr;
        margin-top: 0;
        /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
      }

      .data {
        font-size: 11px;
        color: #6c6c6c;

        .bom:nth-child(1) {
          border-bottom: 1px solid #bcbcbc;
        }

        .bom {
          display: flex;
          flex-direction: column;
          padding: 10px 0;

          .em {
            display: flex;

            .name {
              width: 60px;
              text-align: left;
              margin-right: 10px;
            }

            .num {
              font-size: 14px;
              color: #3d3d3d;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  // 能耗统计
  .tongji {
    background: #fff;
    box-sizing: border-box;
    padding-left: 18px;
    padding-right: 13px;
    padding-bottom: 11px;
    height: 250px;
    overflow: hidden;
    margin-top: 8px;

    .titles {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #5f5f5f;
      margin-top: 12px;
      margin-bottom: 12px;
    }
  }

  .tongji_box {
    border: 1px solid #ccc;
    height: 93px;
    margin-bottom: 2px;

    .top {
      display: flex;
      justify-content: space-between;
      padding: 2px 10px;
      font-size: 13px;
      font-weight: bold;
      color: #3d3d3d;
      height: 50%;
      align-items: center;
    }

    .bom {
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      color: #6c6c6c;
      align-items: center;
      background: #f4f4f4;
      height: 50%;
    }
  }

  // echart图
  .echart {
    background: #fff;
    /* height: 164px; */
    height: 250px;
    box-sizing: border-box;
    position: relative;
    margin-top: 8px;

    .titles {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #5f5f5f;
      line-height: 47px;
      padding-left: 23px;
    }

    .box {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .params {
        position: absolute;
        bottom: 8px;
        width: 90%;
        display: flex;

        .left {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 40%;
          height: 85px;
          background: #f4f4f4;
          margin-right: 11px;

          .num {
            font-size: 24px;
            color: #ff6600;
            margin-bottom: 6px;
          }

          .txt {
            font-size: 13px;
            color: #3d3d3d;
          }
        }

        .right {
          flex: 1;
          display: flex;
          flex-direction: column;
          height: 85px;
          justify-content: space-between;

          .em {
            height: 24px;
            background: #f4f4f4;
            font-size: 12px;
            color: #3d3d3d;
            display: flex;
            line-height: 24px;

            .txt {
              width: 60px;
              text-align: center;
            }

            .num {
              flex: 1;
              text-align: center;
            }
          }
        }
      }
    }

    .pro {

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 5px;
      margin-bottom: 18px;

      >.txt {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3d3d3d;
        margin-top: 6px;
        margin-bottom: 10px;
      }

      >.pt {
        font-size: 11px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #777777;
        margin-top: -6px;
      }
    }
  }

  // 建筑概况
  .jianchu {
    background: #fff;
    box-sizing: border-box;
    padding-left: 23px;
    padding-right: 13px;
    padding-bottom: 8px;
    overflow: hidden;
    height: 250px;
    margin-top: 8px;

    .titles {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #5f5f5f;
      margin-top: 10px;
      margin-bottom: 14px;
    }

    img {
      width: 100%;
      height: 195px;
      object-fit: cover;
      background: burlywood;
    }

    .top {
      .more {
        display: flex;
        height: 94px;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
        color: #b8b8b8;
        border: 1px solid #d2d2d2;
        font-size: 14px;
        white-space: nowrap;
        cursor: pointer;

        p {
          margin-bottom: 0;
        }
      }

      .box {
        display: flex;
        flex-direction: column;
        border: 1px solid #e8e8e8;
        border-bottom: none;

        .rows {
          display: flex;
          border-bottom: 1px solid #e8e8e8;


          .t {
            height: 30px;
            line-height: 30px;
            width: 40%;
            text-align: center;
            border-right: 1px solid #e8e8e8;
            font-size: 13px;
            font-family: Microsoft YaHei;
            color: #3d3d3d;
          }

          .name {
            flex: 1;
            height: 30px;
            line-height: 30px;
            text-align: center;
            box-sizing: border-box;
            padding: 0 10px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            color: #636363;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .bottom {
      margin-top: 15px;

      .rows {
        background: #f4f4f4;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-family: Microsoft YaHei;
        color: #6c6c6c;
        height: 86px;

        .num {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #3d3d3d;
          width: 119%;
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }

  .p_all {
    display: flex;
    color: #fff;
    height: 100%;
    box-sizing: border-box;
    font-size: 14px;
    height: 62px;
    margin-top: 8px;
    font-size: 26px;
    padding-left: 10px;
    align-items: center;
    font-weight: 200;
  }

  .p_all p {
    font-size: 18px;
    margin: 0;
    font-family: "element-icons";
  }

  .card_box .p {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 30px;
    color: #dbe7fd6b;
  }

  .card-panel {
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);
    height: 79px;
    background: #8c79ac;
    border: 2px solid #79669b;
    margin: 10px 0;
    margin-bottom: 0;

    .card-panel-icon-wrapper {
      float: left;
      transition: all 0.38s ease-out;
      display: flex;
      flex-direction: column;
      color: #fff;
      height: 100%;
      width: 35%;
      justify-content: center;
      text-align: center;

      >img {
        width: 47px;
        margin: 3px auto;
      }

      >div {
        font-size: 50px;
        margin-bottom: 0;
      }

      p {
        font-size: 16px;
        margin-bottom: 0;
      }
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }

  .el-icon-top {
    color: #ff8522;
    font-weight: bold;
  }

  .el-icon-bottom {
    color: #4cb546;
    font-weight: bold;
  }
</style>